module.exports = __webpack_public_path__ + "chat-bubble.2825414680777310a4ba.png";